import React, { useState, useEffect } from 'react';
import { storage } from '../firebaseConfig';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import LogoBanner from '../Assets/Gallery/LogoBanner.png'
import HogCrowd from '../Assets/Gallery/Hogs_Crowd.png'
import HogPete from '../Assets/Gallery/Hogs_Pete.png'
import Band from '../Assets/Gallery/BandB&W_04.2025.png'
import Pete from '../Assets/Gallery/Pete.png'
import XFiles from '../Assets/Gallery/XFiles.png'
import Cassettes from '../Assets/Gallery/Cassettes.png'
import Simpsons from '../Assets/Gallery/WITB_Simpsons_FINAL.png'
import TMNT from '../Assets/Gallery/TMNT.png'
import Walter from '../Assets/Gallery/WALTER.png'
import PeteYO from '../Assets/Gallery/Pete_04.2025.png'
import BandYO from '../Assets/Gallery/BandB&W_2_04.2025.png'

import { Carousel } from 'react-bootstrap'
import '../CSS/Gallery.css';


const Gallery = () => {
  const imageUrls = [BandYO, Cassettes, Walter, HogPete, Simpsons,  LogoBanner, TMNT, PeteYO, XFiles];

  return (
    <div id="gallery">
      <Carousel interval={3000}> {/* Carousel will auto-scroll every 3 seconds */}
        {imageUrls.map((url, index) => (
          <Carousel.Item key={index}>
            <img
              className="gallery-image"
              src={url}
              alt={`Gallery ${index + 1}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Gallery;